import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

function EditButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <Button disabled={disabled} className="btn-wd btn-outline mr-1" type="submit" variant="warning" onClick={handler} style={{ width: "100%" }}>
      {disabled ? (
        <div>
          <i className="fa fa-circle-notch fa-spin"></i>
          <span>{t("messages.pleaseWait")}</span>
        </div>
      ) : (
        <div>
          <i className="fa fa-edit" />
          <span>{t("common.actions.edit")}</span>
        </div>
      )}
    </Button>
  );
}

export default EditButton;
